module.exports = __webpack_public_path__ + "static/grafika10-d68d11368d9bf6e3c7dcb8d0ece26d93.png";